import React from "react";
import { createPortal } from "react-dom";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import ALERT_IMAGE from "../../../assets/images/modal_top_image.png";
import { capitalizeWords } from "~/Utils/Utils";
import { useTranslation } from "react-i18next";

interface ModalProps {
  title: string;
  children: React.ReactNode;
  onClose: () => void;
  overFlowUnset?: boolean;
  actions?: React.ReactNode;
  testId?:string;
}

export const SIMPLModal: React.FC<ModalProps> = ({
  children,
  actions,
  title,
  onClose,
  overFlowUnset = false,
  testId
}) => {
  const { t } = useTranslation();
  const modalRoot = document.getElementById("root") as HTMLElement;

  const modalScrollClasses = [
    "bg-white",
    "mx-auto",
    "rounded-xl",
    "min-h-[150px]",
    "min-w-[400px]",
    "max-w-[90%] sm:max-w-[633px]",
    "max-h-screen",
    "z-[50]",
    !overFlowUnset && "overflow-auto",
  ]
    .filter(Boolean)
    .join(" ");

  return createPortal(
    <div className="fixed inset-0 flex h-[1500vh] items-start justify-center bg-black bg-opacity-60 w-full transition-opacity z-40"
     data-test-id={testId}>
      <div className="flex flex-col w-full max-w-[90%] sm:max-w-[633px] px-2 py-2 relative mt-4">
        <div id="modal-popup-container" />
        <div id="modal-scroll-container" className={modalScrollClasses}>
          {/* Top Image */}
          <div className="w-full h-[15px]">
            <img
              src={ALERT_IMAGE}
              alt="top_image"
              className="w-full  object-cover"
            />
          </div>
          {/* Top Image */}
          <div className="w-full h-[55px]">
            <img
              src={ALERT_IMAGE}
              alt="Modal header decoration"
              className="w-full h-[15px] object-cover"
            />
          </div>
          {/* Header */}
          <div className="flex items-center justify-between w-full h-auto p-6 gap-2">
            <h2
              className="flex-1 font-arial text-[24px] font-bold leading-[36px] text-left text-[#002B6E] normal-case tracking-normal"
              data-testid="modal-title"
            >
              {title}
            </h2>
            <div className="w-[24px] h-[24px] flex items-center justify-center">
              <button onClick={onClose} aria-label={t("CloseModal")} type="button">
                <CloseOutlinedIcon />
              </button>
            </div>
          </div>

          {/* Content */}
          <div
            className="mt-2 w-full h-auto p-6 pb-8 pt-6 gap-0 border-b border-[#CED0D5]"
            data-testid="modal-content"
          >
            <div className="gap-0 font-arial text-[16px] font-normal leading-[28px] text-left break-words">
              {children}
            </div>
          </div>

          {/* Actions */}
          {actions && (
            <div className="w-full h-auto flex flex-row justify-end items-center p-6 px-10">
              <div className="w-auto flex items-center">{actions}</div>
            </div>
          )}
        </div>
      </div>
    </div>,
    modalRoot
  );
};
